import { render, staticRenderFns } from "./HeaderContentsWithNoNavigation.vue?vue&type=template&id=2ed2bf92&"
import script from "./HeaderContentsWithNoNavigation.vue?vue&type=script&lang=js&"
export * from "./HeaderContentsWithNoNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports